import type {
  SpreadsheetDataBulkResponse, SpreadsheetDataErrorResponse, SpreadsheetTableResponse,
} from '~/spreadsheet/spreadsheet.repository';

export const isErrorSpreadsheet = (
  spreadsheetResponse: SpreadsheetDataErrorResponse | SpreadsheetDataBulkResponse | SpreadsheetTableResponse | null | undefined,
): spreadsheetResponse is SpreadsheetDataErrorResponse => {
  if (!spreadsheetResponse) {
    return false;
  }
  if (('error' in spreadsheetResponse) && spreadsheetResponse.error) {
    return true;
  }
  return false;
};

export const isSuccessBulkSpreadsheet = (
  spreadsheetResponse: SpreadsheetDataErrorResponse | SpreadsheetDataBulkResponse | null | undefined,
): spreadsheetResponse is SpreadsheetDataBulkResponse =>
  !isErrorSpreadsheet(spreadsheetResponse);

export const isSuccessRawSpreadsheet = (
  spreadsheetResponse: SpreadsheetDataErrorResponse | SpreadsheetTableResponse | null | undefined,
): spreadsheetResponse is SpreadsheetTableResponse =>
  !isErrorSpreadsheet(spreadsheetResponse);
